import { render, staticRenderFns } from "./ProductCases.vue?vue&type=template&id=49efe4e3&"
import script from "./ProductCases.vue?vue&type=script&lang=js&"
export * from "./ProductCases.vue?vue&type=script&lang=js&"
import style0 from "./ProductCases.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports